import React, { useState, useEffect } from "react";
import { Trash2 } from "lucide-react";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../components/common/Loader";

const AllContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const allContact = () => {
    setIsLoading(true);
    setError("");

    axios
      .get(`${process.env.REACT_APP_API_URL}/contact/get-all`)
      .then((response) => {
        const startTime = Date.now();
        setContacts(response?.data?.data || []);
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(1000 - elapsed, 0);
        setTimeout(() => setIsLoading(false), remaining);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to fetch contacts.");
      })
      .finally(() => setTimeout(() => setIsLoading(false), 1000));
  };

  useEffect(() => {
    allContact();
  }, []);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_API_URL}/contact/delete/${id}`)
          .then(() => {
            Swal.fire({
              title: "Deleted!",
              text: "Contact has been deleted.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
            allContact();
          })
          .catch((error) => {
            console.error("Delete error:", error);
            Swal.fire({
              title: "Error!",
              text: "Something went wrong while deleting the contact.",
              icon: "error",
            });
          });
      }
    });
  };

  return (
    <div className="min-h-screen p-6 dashboardContainer">
      <div className="w-full mx-auto">
        <div className="mb-4 mt-6 flex justify-between items-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-primaryTextColor">
            Inquiries
          </h1>
        </div>

        {isLoading ? (
          <Loader />
        ) : error ? (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">⚠️</div>
            <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
              Error Loading Contacts
            </h3>
            <p className="text-secondaryTextColor">{error}</p>
          </div>
        ) : contacts.length === 0 ? (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">📭</div>
            <h3 className="text-2xl font-bold text-primaryTextColor mb-2">
              No Inquiries Found
            </h3>
            <p className="text-secondaryTextColor">
              You have not received any inquiries yet.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {contacts.map((contact) => (
              <div
                key={contact._id}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 p-5 relative"
              >
                <button
                  onClick={() => handleDelete(contact._id)}
                  className="absolute top-3 right-3 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition"
                >
                  <Trash2 size={16} />
                </button>

                <h3 className="text-lg font-bold text-primaryTextColor mb-1">
                  {contact?.name || "N/A"}
                </h3>
                <p className="text-sm text-secondaryTextColor mb-1">
                  <span className="font-semibold">Email:</span>{" "}
                  {contact?.email || "N/A"}
                </p>
                <p className="text-sm text-secondaryTextColor mb-1">
                  <span className="font-semibold">Phone:</span>{" "}
                  {contact?.phone || "N/A"}
                </p>
                <p className="text-sm text-secondaryTextColor mb-1">
                  <span className="font-semibold">Centre:</span>{" "}
                  {contact?.centre || "N/A"}
                </p>
                <p className="text-sm text-gray-600 mt-3 line-clamp-3">
                  {contact?.message || "No message provided."}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AllContacts;
